import axios, { type AxiosResponse } from 'axios';

import { type AxiosRequestConfig } from '@type/api';

import { camelizeResponse, decamelizeRequest, handleErrorResponse } from './utils';

axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest'
};

axios.defaults.withCredentials = true;

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

// Camelize responses from the server
axios.interceptors.response.use(camelizeResponse, handleErrorResponse);

// Decamelize requests
axios.interceptors.request.use(decamelizeRequest, (error) => Promise.reject(error));

export const deleteData = <T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    config?: AxiosRequestConfig<D>
): Promise<R> => axios.delete(url, config);

export const fetchData = <T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    config?: AxiosRequestConfig<D>
): Promise<R> => axios.get(url, config);

export const fetchOptions = <T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    config?: AxiosRequestConfig<D>
): Promise<R> => axios.options(url, config);

export const postData = <T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig<D>
): Promise<R> => axios.post(url, data, config);

export const putData = <T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig<D>
): Promise<R> => axios.put(url, data, config);

export const patchData = <T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig<D>
): Promise<R> => axios.patch(url, data, config);
